module.exports = __webpack_public_path__ + "img/page.fbd525b2.png";